// ============================================================================
// Configuration & State
// ============================================================================

let config = {
    isMainCart: location.pathname.includes('/cart'),
    defaultCheckoutButton: null,
    checkoutPlusButton: null,
    spLocation: null,
    spInsertType: null,
    quoteState: null
};

let state = {
    SPOffer: {},
    cart: null
};

// ============================================================================
// Initialization
// ============================================================================

function initializeCheckoutPlus(cart) {
    setupConfiguration();
    setupEventListeners();
    window.dispatchEvent(new Event('extendSPHelperLoaded'));
    renderOrUpdate(cart);
}

// ============================================================================
// Configuration
// ============================================================================

function setupConfiguration() {
    if (config.isMainCart) {
        config.defaultCheckoutButton = '.checkout-button';
        config.checkoutPlusButton = '.extend-checkout-plus-button';
        config.spLocation = '.cart-actions';
        config.spInsertType = 'before';
    } else {
        config.defaultCheckoutButton = '.picky-cart__button';
        config.checkoutPlusButton = '.extend-checkout-plus-button-side';
        config.spLocation = '.picky-cart__footer';
        config.spInsertType = 'before';
    }
}

// ============================================================================
// Shipping Protection Quote
// ============================================================================

function getSPQuote(cartItems) {
    return new Promise(resolve => {
        window.Extend.shippingProtection.getUpdatedSPQuote({
            items: cartItems,
            onUpdate: ({ quote, attachBehavior }) => {
                resolve({ quote, attachBehavior });
            }
        });
    });
}

// ============================================================================
// Learn More Functionality
// ============================================================================

function addLearnMoreClickListener(attempts = 0) {
    const spOfferSelector = config.isMainCart ? '#extend-shipping-offer-main' : '#extend-shipping-offer-side';
    const iframeElement = document.querySelector(`${spOfferSelector} div iframe`);
    if (!iframeElement && attempts < 50) {
        setTimeout(() => addLearnMoreClickListener(attempts + 1), 100);
        return;
    }

    setTimeout(() => {
        try {
            const iframeDocument = iframeElement?.contentDocument;
            const iframeBody = iframeDocument?.querySelector('body');
            const learnMoreButton = iframeBody?.querySelector('.shipping-info-button');
            const infoIcon = document.querySelector('.checkout-plus-info-icon');
            if (infoIcon && learnMoreButton) {
                infoIcon.style.display = 'inline-block';
                infoIcon.addEventListener('click', () => learnMoreButton.click());
            }
        } catch (error) {
            console.warn('Could not access iframe content:', error);
        }
    }, 500);

}

// ============================================================================
// Checkout Plus Offer Creation
// ============================================================================

function createCheckoutPlusOffer(spQuote) {
    // Remove existing offers
    document.querySelectorAll('.checkout-plus-container').forEach(el => el.remove());

    // Create container
    const container = document.createElement('div');
    container.className = 'checkout-plus-container';

    // Create image/icon section
    const imageDiv = createImageSection();
    
    // Create info section
    const infoContainer = createInfoSection(spQuote);

    // Assemble
    container.appendChild(imageDiv);
    container.appendChild(infoContainer);

    // Show checkout plus button
    const checkoutPlusBtn = document.querySelector(config.checkoutPlusButton);
    if (checkoutPlusBtn) {
        checkoutPlusBtn.style.display = 'block';
    }

    return container;
}

function createImageSection() {
    const imageDiv = document.createElement('div');
    imageDiv.className = 'checkout-plus-image';

    const iconRow = document.createElement('div');
    iconRow.className = 'checkout-plus-icon-row';

    const packageIcon = document.createElement('span');
    packageIcon.className = 'checkout-plus-package-icon';
    packageIcon.innerHTML = `
        <svg viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.86368 2.89709C6.3014 4.04539 3.32139 5.37654 2.2414 5.85423C0.866067 6.45876 0.239466 6.76369 0.142615 6.86533L0 7.01261V13.4701C0 18.998 0.0101108 19.943 0.0713075 20.0648C0.13756 20.1869 0.99325 20.5882 6.79045 23.1844C10.4428 24.8255 13.4942 26.167 13.5705 26.167C13.6519 26.167 13.9933 26.0298 14.3347 25.8671C23.56 21.3604 25.8625 20.2121 25.9541 20.0953C26.056 19.9632 26.056 19.8719 26.0711 13.5259C26.0813 7.4696 26.0762 7.07843 25.9948 6.94123C25.9184 6.82446 24.8129 6.26052 19.8666 3.82672C16.5455 2.19595 13.7642 0.84437 13.6775 0.834021C13.5604 0.818893 12.506 1.2711 8.86368 2.89709ZM18.9345 4.57881C21.8433 6.00656 24.2323 7.18511 24.2427 7.19546C24.2733 7.22598 19.6173 9.50215 19.5308 9.50215C19.4544 9.50215 8.5734 4.35536 8.51247 4.28928C8.4973 4.26884 8.50741 4.24867 8.53296 4.23328C8.56355 4.2232 9.7098 3.71499 11.0801 3.10037C12.4554 2.48548 13.5915 1.98259 13.6118 1.98259C13.6317 1.98232 16.0309 3.15106 18.9345 4.57881ZM12.4397 7.37327C15.333 8.75006 17.8293 9.93392 17.9921 10.0101L18.2773 10.1473L15.9189 11.3006L13.5655 12.459L7.74804 9.85245C4.5541 8.41462 1.93568 7.23075 1.93568 7.21032C1.93568 7.17476 7.02459 4.88851 7.11638 4.88346C7.15204 4.87842 9.54616 6.00125 12.4397 7.37327ZM7.03497 10.7417L12.9644 13.399L12.9796 19.0742C12.9846 22.1937 12.9745 24.7443 12.954 24.7443C12.9285 24.7443 10.2491 23.5503 6.99399 22.0921L1.06988 19.4348V13.7546C1.06988 10.6351 1.07493 8.07944 1.08505 8.07944C1.09516 8.07944 3.76945 9.27843 7.03497 10.7417ZM24.9504 13.8003L24.9353 19.4704L19.5457 22.1075C16.5758 23.5554 14.141 24.7446 14.1309 24.7446C14.1208 24.7446 14.1154 22.194 14.1208 19.0744L14.1359 13.4043L19.5101 10.7723C22.4645 9.32434 24.8996 8.13544 24.9249 8.13544C24.9454 8.13013 24.9558 10.6807 24.9504 13.8003Z" fill="black"/>
            <path d="M2.59274 10.6663C2.47567 10.7881 2.44507 10.8595 2.44507 11.0373C2.44507 11.1645 2.48578 11.3017 2.53686 11.3677C2.66937 11.5405 5.63395 12.9223 5.86836 12.9276C6.0924 12.9327 6.34197 12.7244 6.38295 12.511C6.41355 12.3483 6.3167 12.0994 6.18419 11.9877C6.12805 11.9471 5.42003 11.5965 4.6101 11.2154C2.95939 10.4376 2.85243 10.4121 2.59274 10.6663Z" fill="black"/>
            <path d="M2.7263 12.712C2.43096 12.8694 2.34422 13.2964 2.5632 13.535C2.70076 13.6926 5.66029 15.0898 5.85399 15.0898C6.06286 15.0898 6.30738 14.912 6.3582 14.7239C6.40902 14.5256 6.35314 14.2921 6.23075 14.17C6.09346 14.0381 3.09801 12.651 2.95539 12.651C2.88409 12.651 2.78218 12.6815 2.7263 12.712Z" fill="black"/>
            <path d="M27.4631 13.5371C29.2256 14.6578 30.718 15.1198 31.9172 15.0098L32.6096 14.9463L32.6438 15.6406C32.7711 18.2224 32.3627 20.3419 31.4495 21.9971C30.53 23.6634 29.1258 24.8096 27.3606 25.4766L27.1282 25.5645L26.8958 25.4785C25.1855 24.8523 23.8006 23.7589 22.8743 22.0977C21.956 20.4506 21.5152 18.2952 21.5862 15.5811L21.6038 14.8965L22.2874 14.9326C23.8073 15.0124 25.267 14.6873 26.6956 13.5742L27.0667 13.2852L27.4631 13.5371Z" fill="black" stroke="white" stroke-width="1.33333"/>
        </svg>
    `;

    iconRow.appendChild(packageIcon);
    imageDiv.appendChild(iconRow);

    return imageDiv;
}

function createInfoSection(spQuote) {
    const infoContainer = document.createElement('div');
    infoContainer.className = 'checkout-plus-info-container';

    const topRow = document.createElement('div');
    topRow.className = 'checkout-plus-top-row';

    const titleAndIconContainer = document.createElement('div');
    titleAndIconContainer.className = 'checkout-plus-title-icon-container';

    const title = document.createElement('span');
    title.className = 'checkout-plus-title';
    title.innerHTML = `
        Extend Checkout+
        <svg class="checkout-plus-info-icon" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 0.318359C10.6903 0.318359 13.6816 3.30973 13.6816 7C13.6816 10.6903 10.6903 13.6816 7 13.6816C3.30973 13.6816 0.318359 10.6903 0.318359 7C0.318359 3.30973 3.30973 0.318359 7 0.318359Z" stroke="black" stroke-width="0.636364"/>
            <path d="M7.58743 4.35647H6.41261V3.18164H7.58743V4.35647ZM7.58743 9.64318V5.53129H5.8252V6.70612H6.41261V9.64318H5.8252V10.818H8.17485V9.64318H7.58743Z" fill="black"/>
        </svg>
    `;

    titleAndIconContainer.appendChild(title);

    const price = document.createElement('span');
    price.className = 'checkout-plus-price';
    price.textContent = spQuote;

    topRow.appendChild(titleAndIconContainer);

    const checkoutPlusBtn = document.querySelector(config.checkoutPlusButton);
    if (checkoutPlusBtn) {
        checkoutPlusBtn.appendChild(price);
    }

    const subtext = document.createElement('span');
    subtext.className = 'checkout-plus-subtext';
    subtext.textContent = 'Added protection against loss, theft, or damage';

    infoContainer.appendChild(topRow);
    infoContainer.appendChild(subtext);

    return infoContainer;
}

// ============================================================================
// Add/Update Checkout Plus Offer
// ============================================================================

async function addOrUpdateCheckoutPlusOffer(localCart) {
    try {
        const mappedCartItems = ExtendShopify.spCartMapper(localCart.items);
        const response = await getSPQuote(mappedCartItems);
        
        const quotePremium = response.quote.premium;
        const quoteFormatted = formatCentsToDollars(quotePremium);

        const checkoutPlusButton = document.querySelector(config.checkoutPlusButton);
        
        if (checkoutPlusButton) {
            // Add click handler to opt into SP
            checkoutPlusButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                updateSPoptin(true);
            });

            // Create and insert checkout plus offer
            const checkoutPlusOffer = createCheckoutPlusOffer(quoteFormatted);
            addLearnMoreClickListener();
            checkoutPlusButton.before(checkoutPlusOffer);
        }
    } catch (err) {
        console.error('Error adding checkout plus offer:', err);
    }
}

// ============================================================================
// Update SP Opt-in
// ============================================================================

async function updateSPoptin(enabled) {
    try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const updatedAttributes = {
            ...cart.attributes,
            'Extend Shipping Protection': enabled ? 'selected' : 'declined'
        };

        const updateResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ attributes: updatedAttributes })
        });

        await updateResponse.json();
        
        // Navigate to checkout
        window.location.href = '/checkout';
    } catch (error) {
        console.error('Error updating cart:', error);
    }
}

// ============================================================================
// Render or Update SP Offer
// ============================================================================

function dispatchSpQuoteUpdate(source, quote, extra = {}) {
  window.dispatchEvent(
    new CustomEvent('quoteUpdate', {
      detail: { source, quote, ...extra },
    }),
  );
}

function renderOrUpdate(spcart) {
    const cartType = config.isMainCart ? 'main' : 'side';
    const mappedCartItems = ExtendShopify.spCartMapper(spcart.items);

    // Update or create SP offer
    if (Extend.shippingProtection?._instance && state.SPOffer[cartType]) {
        // Insert if not in DOM
        if (!document.querySelector(`#extend-shipping-offer-${cartType}`)) {
            InsertOffer();
        }
        // Update existing offer
        Extend.shippingProtection.update({ items: mappedCartItems });
    } else {
        // Create new offer
        state.SPOffer[cartType] = document.createElement('div');
        state.SPOffer[cartType].id = `extend-shipping-offer-${cartType}`;
        InsertOffer();
        const isShippingProtectionInCart = ExtendShopify.shippingProtectionInCart(spcart.items);
        Extend.shippingProtection.render({
            selector: `#extend-shipping-offer-${cartType}`,
            items: mappedCartItems,
            isShippingProtectionInCart,
            convertQuoteToFormattedDisplayPrice: async (quote) => {
                dispatchSpQuoteUpdate('render/format', quote);
                return ExtendShopify.convertQuoteToFormattedDisplayPrice(quote);
            },
            onEnable: (quote) => {dispatchSpQuoteUpdate('enable', quote)},
            onDisable: (quote) => {dispatchSpQuoteUpdate('disable', quote)},
            onUpdate: (quote, spActions) => {dispatchSpQuoteUpdate('update', quote, { spActions })},
        })
        addLearnMoreClickListener();
    }

    // Initialize buttons only once
    if (!state.buttonsInitialized) {
        initializeCheckoutButtons();
        state.buttonsInitialized = true;
    }
}

function initializeCheckoutButtons(attempts) {
    let attempt = attempts ? attempts : 0;


    const merchantCheckoutButton = document.querySelector(config.defaultCheckoutButton);
    if (!merchantCheckoutButton  && attempt < 50) {
        window.setTimeout(function() {initializeCheckoutButtons(attempt++)}, 100)
    }
    else {

        if (!merchantCheckoutButton) {
            console.error('Could not find default checkout button');
            return;
        }

        // Store original button state
        state.originalButton = merchantCheckoutButton.cloneNode(true);
        
        // Create checkout+ button once
        const checkoutPlusButton = document.createElement('button');
        if (!config.isMainCart) {
            checkoutPlusButton.classList = 'btn btn--primary btn--style-two btn--full mini-cart__checkout ' + config.checkoutPlusButton;
        } else {
            checkoutPlusButton.classList = '.cart__checkout-button button ' + config.checkoutPlusButton;
        }
        checkoutPlusButton.innerText = 'Checkout+';
        checkoutPlusButton.style.display = 'none'; // Hidden by default
        merchantCheckoutButton.parentElement.prepend(checkoutPlusButton);
        // Store reference
        state.checkoutPlusButton = checkoutPlusButton;

        checkoutPlusButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            updateSPoptin(true);
        });
        
        // Setup event listener once
        window.addEventListener('quoteUpdate', handleQuoteUpdate);

        // Theme Specific
    }

}

function handleQuoteUpdate(event) {
    const quote = event.detail.quote;
    const premium = quote.premium;
    
    config.quoteState = premium;
    
    const merchantCheckoutButton = document.querySelector(config.defaultCheckoutButton);
    const checkoutPlusButton = state.checkoutPlusButton;
    
    if (!merchantCheckoutButton || !checkoutPlusButton) return;
    
    if (premium === 0) {
        // Hide checkout+ button
        checkoutPlusButton.style.setProperty('display', 'none', 'important');
        
        // Restore original merchant button
        const currentButton = document.querySelector(config.defaultCheckoutButton);
        if (currentButton && state.originalButton) {
            const restoredButton = state.originalButton.cloneNode(true);
            currentButton.replaceWith(restoredButton);
        }
    } else {
        checkoutPlusButton.parentElement.style.setProperty('flex-direction', 'column', 'important');
        // Show checkout+ button with premium
        checkoutPlusButton.innerText = `CHECKOUT+ ${formatCentsToDollars(premium)}`;
        checkoutPlusButton.style.setProperty('display', 'block', 'important');

        checkoutPlusButton.style.setProperty('background', '#513629', 'important');
        if (config.isMainCart) {
            checkoutPlusButton.style.setProperty('width', '100%', 'important');
            checkoutPlusButton.style.setProperty('margin-bottom', '10px', 'important');
            checkoutPlusButton.style.setProperty('height', '42px', 'important');
        } else {
            checkoutPlusButton.style.setProperty('height', '50px', 'important');
            checkoutPlusButton.style.setProperty('max-width', '456px', 'important');
        }
        checkoutPlusButton.style.setProperty('border-radius', '24px', 'important');
        checkoutPlusButton.style.setProperty('color', 'white', 'important');
        checkoutPlusButton.style.setProperty('transition', '0.3s', 'important');
        checkoutPlusButton.style.setProperty('font-weight', '400', 'important');
        checkoutPlusButton.style.setProperty('font-size', '16px', 'important');
        checkoutPlusButton.style.setProperty('letter-spacing', '1.25px', 'important');

        // Modify merchant button
        const currentMerchantButton = document.querySelector(config.defaultCheckoutButton);
        if (currentMerchantButton.nodeName.toLowerCase() === 'input') {
            currentMerchantButton.value = 'Continue without checkout+';
        } else {
            currentMerchantButton.innerText = 'Continue without checkout+';
        }
        currentMerchantButton.classList.add('no-co-plus')
        currentMerchantButton.style.setProperty('background', 'none', 'important');
        currentMerchantButton.style.setProperty('border', 'none', 'important');
        currentMerchantButton.style.setProperty('color', 'black', 'important');

        const checkoutPlusOffer = createCheckoutPlusOffer(formatCentsToDollars(premium));
        if (!document.querySelector(config.checkoutPlusButton)) currentMerchantButton.parentElement.prepend(checkoutPlusButton)
        addLearnMoreClickListener();
        checkoutPlusButton.before(checkoutPlusOffer);

        checkoutPlusButton.addEventListener('mouseover', () => {
            checkoutPlusButton.style.setProperty('background', '#c5420c', 'important');
        });

        checkoutPlusButton.addEventListener('mouseout', () => {
            checkoutPlusButton.style.setProperty('background', '#513629', 'important');
        });

    }
}

// ============================================================================
// Insert Offer - Appends invisible SP offer to body
// ============================================================================

function InsertOffer() {
    let cartType = config.isMainCart ? 'main' : 'side';
    const SPOfferEl = state.SPOffer[cartType];
    if (!SPOfferEl) return;
    // Append Extend instance if available
    if (Extend.shippingProtection?._instance && !SPOfferEl.querySelector('.extend-shipping-offer')) {
        SPOfferEl.append(Extend.shippingProtection._instance.el);
    }
    document.querySelector('body').append(SPOfferEl);
}

// ============================================================================
// Normalize Cart
// ============================================================================

function NormalizeCart(cartType = 'main') {
    ExtendShopify.updateExtendLineItems({
        balanceCart: true,
        callback: (err, data) => {
            if (!err && (data?.updates || data?.additions)) {
                if (cartType === 'main') {
                    window.dispatchEvent(new Event('updateExtendSP'));
                } else {
                    window.dispatchEvent(new Event('updateExtendSPSide'));
                }
            }
            renderOrUpdate(data.cart);
        }
    });
}

// ============================================================================
// Utility Functions
// ============================================================================

function formatCentsToDollars(cents) {
    return `$${(cents / 100).toFixed(2)}`;
}

// ============================================================================
// Event Listeners
// ============================================================================

function setupEventListeners() {
    const defaultCheckoutBtn = document.querySelector(config.defaultCheckoutButton);
    
    if (defaultCheckoutBtn) {
        defaultCheckoutBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            updateSPoptin(false);
        });
    }
}

window.initializeCheckoutPlus = initializeCheckoutPlus;